module.exports = __webpack_public_path__ + "static/media/euro-white.200a90ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/euro-white.svg
// module id = 798
// module chunks = 0